<template>
    <div class="sticky z-40 bottom-0">
        <div class="pb-6 pt-3 px-2 bg-white border-b border-t border-gray-200 overflow-hidden md:pb-5 md:px-4">
            <form action="#" @submit.prevent="sendMessage">
                <div class="flex items-start space-x-2 sm:space-x-3">
                    <div class="hidden flex-shrink-0 sm:block">
                        <avatar :user="$page.props.user" class="w-9 h-9"></avatar>
                    </div>
                    <div :class="{ 'self-center': !$page.props.user }" class="flex-1 min-w-0">
                        <label class="sr-only" for="message">Message</label>
                        <textarea
                            v-if="$page.props.auth.check"
                            id="message"
                            ref="messageBody"
                            v-model="form.body"
                            :rows="textareaRows"
                            class="placeholder-gray-700 placeholder-opacity-50 hover:placeholder-opacity-75 block w-full bg-gray-100 border border-transparent rounded-md focus:outline-none resize-none transition duration-100 ease-in-out focus:ring-0"
                            :class="{ 'cursor-not-allowed': disabled }"
                            name="message"
                            :placeholder="disabled ? disabledWarning : 'Aa'"
                            @focus="markAsRead"
                            @keydown="isTyping"
                            @keydown.enter.prevent="handleEnter"
                            :disabled="disabled"
                        ></textarea>
                        <jet-input-error :message="form.errors.body" class="mt-2" />
                    </div>
                    <jet-button class="place-self-center" size="sm" type="submit" :disabled="disabled">
                        <svg class="-mr-1 w-6 h-6 transform rotate-90" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                        </svg>
                    </jet-button>
                </div>
            </form>

            <!--<div v-if="isBot" class="text-gray-300 text-sm font-medium uppercase">Message replies are disabled.</div>-->
        </div>
    </div>
</template>
<script>
import JetInputError from "@/Jetstream/InputError"
import JetButton from "@/Jetstream/Button"

export default {
    components: { JetInputError, JetButton },

    created() {
        this.$root.$on("challengeRequestReviewed", () => this.$refs.messageBody.focus())
    },

    mounted() {
        this.focusTextarea()
    },

    watch: {
        messages() {
            this.focusTextarea()
            this.form.reset()
        },
    },

    props: {
        messages: {
            required: true,
            type: Array | null,
        },

        isBot: {
            default: false,
            type: Boolean,
        },
    },

    computed: {
        disabled() {
            return this.isBot || this.approvedIsNull
        },

        messageables() {
            if (!_.some(this.messages, "messageables")) return null
            return _.map(this.messages, "messageables")
        },

        approvedIsNull() {
            if (!this.messageables) return null
            return this.messageables[0].competitor.approved === null
        },
        competitor() {
            if (!this.messageables) return null
            return this.messageables[0].competitor
        },
        isCompetitor() {
            if (!this.competitor) return null
            return this.competitor.user.id === this.$page.props.user.id
        },
        disabledWarning() {
            if (this.isBot) {
                return "Message replies are disabled."
            }
            if (this.isCompetitor) {
                return "The challenger must respond first."
            }

            return "To enable message replies, Approve or Deny the pending request."
        },
    },

    data() {
        return {
            form: this.$inertia.form({
                _method: "POST",
                body: null,
            }),
            userTyping: {
                profilePhotoUrl: this.$page.props.user.profilePhotoUrl,
                online: this.$page.props.user.online,
            },
            textareaRows: 1,
        }
    },

    methods: {
        handleEnter(e) {
            if (e.shiftKey) return this.newline()
            this.sendMessage()
        },

        markAsRead() {
            if (this.disabled) return null
            axios
                .put(this.route("messenger.conversation.update", { user: this.$page.props.participant.username }))
                .then(() => {
                    let conversationIndex = this.$page.props.conversations.findIndex((conversation) => (conversation.id = this.$page.props.conversation.id))
                    this.$set(this.$page.props.conversations[conversationIndex].readBy, this.$page.props.conversation.type, true)
                })
                .catch((error) => {
                    if (error.response.status === 405) {
                        this.$inertia.visit(this.route("login"))
                    }
                })
        },

        sendMessage() {
            if (!this.form.body || this.form.body.trim() === "") {
                return null
            }

            this.pushMessageToConversation()

            this.form.post(this.route("messenger.message.store", { user: this.$page.props.participant.username }), {
                onSuccess: () => this.form.reset(),
                preserveScroll: true,
            })
        },

        pushMessageToConversation() {
            this.messages.push({
                author: this.$page.props.user,
                body: {
                    text: this.form.body,
                },
                isAuthor: true,
                template: "Default",
            })
            this.$emit("update:messages", this.messages)
            this.$root.$emit("scrollToBottom")
        },

        isTyping(e) {
            if (e.keyCode === 13) return null

            // Set the channel
            let channel = Echo.private(`conversation.${this.$page.props.conversation.id}`)

            // Send the whisper
            setTimeout(() => {
                channel.whisper("typing", {
                    userTyping: this.userTyping,
                    typing: true,
                })
            }, 1200)
        },

        focusTextarea() {
            if (this.$refs.messageBody) {
                this.$refs.messageBody.focus()
            }
        },

        newline() {
            if (this.form.body) {
                if (this.textareaRows < 4) {
                    this.textareaRows = this.textareaRows + 1
                }
                this.form.body = `${this.form.body}\n`
            }
        },
    },
}
</script>
